import { Component, OnDestroy } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { SnackbarService } from '@vendasta/galaxy/snackbar-service';
import { SubscriptionList } from '@vendasta/rx-utils';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { FacebookAdLeadsService } from '../facebook-ad-leads.service';

@Component({
  templateUrl: 'disconnect-dialog-box.component.html',
})
export class DisconnectDialogBoxComponent implements OnDestroy {
  isDisconnecting$: Observable<boolean> = this.facebookAdLeadsService.isDisconnectingPage$;
  pageLabel$: Observable<string> = combineLatest([
    this.facebookAdLeadsService.pageID$,
    this.facebookAdLeadsService.pageName$,
  ]).pipe(map(([id, name]) => name || id));

  private readonly subscriptions = SubscriptionList.new();

  constructor(
    private dialogRef: MatDialogRef<DisconnectDialogBoxComponent>,
    private facebookAdLeadsService: FacebookAdLeadsService,
    private snackbarService: SnackbarService,
    private translateService: TranslateService,
    private router: Router,
  ) {}

  Disconnect(): void {
    this.facebookAdLeadsService.DisconnectFromFacebookPage().subscribe(
      (_) => {
        this.dialogRef.close();
        this.snackbarService.successSnack(
          this.translateService.instant('LEAD_INTEGRATIONS.FACEBOOK.DISCONNECT_SUCCESS_MESSAGE'),
        );
        this.router.navigate(['app-integrations']);
      },
      (_) => {
        this.dialogRef.close();
        this.snackbarService.errorSnack(
          this.translateService.instant('LEAD_INTEGRATIONS.FACEBOOK.DISCONNECT_UNSUCCESSFULL_MESSAGE'),
        );
      },
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.destroy();
  }
}
